<template>
  <v-container>
    <v-row dense>
      <!-- ----------------------------------------------------------------- -->
      <!-- Encabezado -->
      <!-- ----------------------------------------------------------------- -->
      <v-col cols="12">
        <v-card
          dark
          flat
          tile
        >
          <v-img
            src="../assets/img/landscape-morning.jpg"
            gradient="to top, rgba(0,0,0,.44), rgba(0,0,0,.44)"
            max-height="240"
          >
            <v-container class="fill-height">
              <v-row align="center" justify="center">
                <v-col cols="12">
                  <h1 class="text-center display-1">Devoción matutina</h1>
                </v-col>
                <v-col cols="12">
                  <p
                    class="text-center subtitle-1 my-0 text-capitalize"
                  >{{fechaDisplay}}</p>
                </v-col>
              </v-row>
            </v-container>
          </v-img>
          <!-- ------------------------------------------------------------- -->
          <!-- Boton calendario -->
          <!-- ------------------------------------------------------------- -->
          <v-btn
            fab
            absolute
            right
            bottom
            color="secondary"
            class="primary--text"
            @click="dialogFecha = true"
          >
            <v-icon>fas fa-calendar</v-icon>
          </v-btn>
        </v-card>
      </v-col>
      <!-- ----------------------------------------------------------------- -->
      <!-- Matutinas -->
      <!-- ----------------------------------------------------------------- -->
      <v-col
        cols="12"
        md="6"
        v-for="item in matutinas"
        :key="item.id"
      >
        <v-card>
          <v-card-text>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title class="text-uppercase">
                  {{item.titulo}}
                </v-list-item-title>
                <v-list-item-subtitle class="my-2">
                  {{item.libro.tipo}} - {{item.libro.anho}}
                </v-list-item-subtitle>
                <v-divider/>
                <v-list-item-subtitle>
                  <v-btn
                    block
                    color="secondary"
                    class="my-2 primary--text"
                    @click="goMatutina(item)"
                  >Leer</v-btn>
                </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-avatar tile style="height: 200px; width: 120px;">
                <img :src="item.libro.imagen" class="portada">
              </v-list-item-avatar>
            </v-list-item>
          </v-card-text>
        </v-card>
      </v-col>
      <!-- ----------------------------------------------------------------- -->
      <!-- Alerta -->
      <!-- ----------------------------------------------------------------- -->
      <v-col cols="12" v-if="!matutinas.length">
        <v-alert type="info">
          No hay matutinas registradas para la fecha seleccionada
        </v-alert>
      </v-col>
      <!-- ----------------------------------------------------------------- -->
      <!-- Seleccionar fecha -->
      <!-- ----------------------------------------------------------------- -->
      <v-dialog v-model="dialogFecha" max-width="300">
        <v-date-picker v-model="fecha" width="300"></v-date-picker>
      </v-dialog>
    </v-row>
  </v-container>
</template>

<script>
import { mapMutations } from 'vuex'
import { CONTENT_API } from '../config'
import dayjs from 'dayjs'
import 'dayjs/locale/es'
dayjs.locale('es')
export default {
  name: 'libros',
  data () {
    return {
      dialogFecha: false,
      fecha: '',
      matutinas: []
    }
  },
  computed: {
    fechaDisplay () {
      return dayjs(this.fecha).format('dddd, MMMM D, YYYY')
    }
  },
  methods: {
    ...mapMutations(['setMatutina']),
    goMatutina (item) {
      this.setMatutina(item)
      this.$router.push({ name: 'matutina' })
    },
    getMatutinas () {
      this.$http.matutinas
        .get(`?fecha_eq=${this.fecha}`)
        .then(res => res.data)
        .then(res => {
          res.forEach(i => {
            i.libro.imagen = `${CONTENT_API}${i.libro.imagen.url}`
          })
          this.matutinas = res
        })
    }
  },
  mounted () {
    this.fecha = dayjs().format('YYYY-MM-DD')
  },
  watch: {
    fecha () {
      this.dialogFecha = false
      this.getMatutinas()
    }
  }
}
</script>

<style>
  .portada {
    width: 120px;
    height: 200px;
    object-fit: cover;
  }
</style>
